import React, { useMemo } from 'react';
import JoditEditor from 'jodit-react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import style from './WYSIWYGArea.module.scss';

interface IWYSIWYGArea {
	onChange: (value: string) => void;
	value: string;
	testId?: string;
	placeholder?: string;
	containerClassName?: string;
}

const WYSIWYGArea: React.FC<IWYSIWYGArea> = ({
	onChange,
	value,
	testId,
	placeholder = 'inputPlaceholder',
	containerClassName,
}) => {
	const { t } = useTranslation('form');
	const containerClasses = classNames(style.container, containerClassName);

	const config = useMemo(
		() => ({
			height: '250',
			placeholder: t(placeholder),
		}),
		[t],
	);

	return (
		<div data-test={testId} className={containerClasses}>
			<JoditEditor onChange={onChange} value={value} config={config} />
		</div>
	);
};

export default React.memo(WYSIWYGArea);
